import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyBookingInforComponent } from './my-booking-infor.component';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [MyBookingInforComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule],
  exports: [MyBookingInforComponent],
})
export class MyBookingInforModule {}
